'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoMicC = function IoMicC(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.7 2.5c2.3 0 4.3 1.8 4.3 4.1v2.2h-4.6v2.8h4.6v3.4h-4.6v2.9h4.6v3.4h-4.6v2.8h4.6v3.3c0 2.3-2 4.1-4.3 4.1h-2.3v6h-6.8v-6h-2.3c-2.3 0-4.3-1.8-4.3-4.1v-3.3h11.9v-2.8h-11.9v-3.4h11.9v-2.9h-11.9v-3.4h11.9v-2.8h-11.9v-2.2c0-2.3 1.9-4.1 4.3-4.1h11.4z' })
        )
    );
};

exports.default = IoMicC;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/mic-c.js
// module id = 2353
// module chunks = 0